import {getPlaceConfig} from "./place";

const config = getPlaceConfig(3);

export default config
